<script>
import Modal from "../../../theme/organisms/Modal.vue";
import BasicForm from "../../../theme/molecules/BasicForm.vue";
import FormInputBuilder from "../../../theme/molecules/FormInputBuilder.vue";
import FormFields from "../services/SpaceFormDefinition";
export default {
  name: "AddNewFormModal",
  components: {
    FormInputBuilder,
    BasicForm,
    Modal,
  },
  data() {
    return {
      fields: FormFields,
      model: {},
      errors: {},
      show: false,
    }
  },
  methods: {
    handleSuccess(event) {
      this.show = false;
      const id = event.data.data.id;

      window.location.href = `/space/forms/${id}#fields`;
      this.$emit('close');
    },
    open() {
      this.show = true
    },
  },
}
</script>

<template>
  <modal :title="trans('general.page.space_forms.add_form_title')" v-model="show" size="lg">
    <basic-form action="/space/forms/new" method="post" @success="handleSuccess" @validations="errors = $event">
        <form-input-builder :fields="fields" v-model="model" :errors="errors"/>
    </basic-form>
  </modal>
</template>
